import axios from 'axios';
import { BASE_PATH_SERVER } from './config';

// Migrado a axios: Authorization + retry 401 vía interceptor global. El primer
// parámetro `_token` se conserva (ignorado) para no correr posiciones de los
// callers; lo inyecta el interceptor. Contrato preservado: estas funciones
// NUNCA rechazan — ante error (incl. 4xx) devuelven { status:'client', ... } con
// el message del backend si lo hay (los callers chequean result?.status).
const catchErr = (err) => ({
  status: 'client',
  codeMessage: 'ERROR_EN_LA_PETICION',
  message: err?.response?.data?.message || err?.message,
});

export const getPdfTemplatesApi = async () => {
  try {
    const { data } = await axios.get(`${BASE_PATH_SERVER}pdf-templates`);
    return data;
  } catch (err) {
    return catchErr(err);
  }
};

export const getPdfTemplateByTypeApi = async (_token, documentType) => {
  try {
    const { data } = await axios.get(`${BASE_PATH_SERVER}pdf-templates/${documentType}`);
    return data;
  } catch (err) {
    return catchErr(err);
  }
};

export const createPdfTemplateApi = async (_token, template) => {
  try {
    const { data } = await axios.post(`${BASE_PATH_SERVER}pdf-templates`, template);
    return data;
  } catch (err) {
    return catchErr(err);
  }
};

export const createPdfTemplateDefaultApi = async (_token, documentType) => {
  try {
    const { data } = await axios.post(`${BASE_PATH_SERVER}pdf-templates/${documentType}/default`);
    return data;
  } catch (err) {
    return catchErr(err);
  }
};

export const updatePdfTemplateApi = async (_token, id, template) => {
  try {
    const { data } = await axios.put(`${BASE_PATH_SERVER}pdf-templates/${id}`, template);
    return data;
  } catch (err) {
    return catchErr(err);
  }
};

export const deletePdfTemplateApi = async (_token, id) => {
  try {
    const { data } = await axios.delete(`${BASE_PATH_SERVER}pdf-templates/${id}`);
    return data;
  } catch (err) {
    return catchErr(err);
  }
};

// Cross-tenant admin APIs: el super-tenant (liftlogic) edita plantillas de
// cualquier tenant via path scoped /admin/tenants/:tenantId/pdf-templates/*.
// El backend valida liftlogic + override TenantProvider antes del service.
const adminBase = (tenantId) => `${BASE_PATH_SERVER}admin/tenants/${tenantId}/pdf-templates`;

export const getPdfTemplatesAdminApi = async (_token, tenantId) => {
  try {
    const { data } = await axios.get(adminBase(tenantId));
    return data;
  } catch (err) {
    return catchErr(err);
  }
};

export const getPdfTemplateByTypeAdminApi = async (_token, tenantId, documentType) => {
  try {
    const { data } = await axios.get(`${adminBase(tenantId)}/${documentType}`);
    return data;
  } catch (err) {
    return catchErr(err);
  }
};

export const createPdfTemplateAdminApi = async (_token, tenantId, template) => {
  try {
    const { data } = await axios.post(adminBase(tenantId), template);
    return data;
  } catch (err) {
    return catchErr(err);
  }
};

export const createPdfTemplateDefaultAdminApi = async (_token, tenantId, documentType) => {
  try {
    const { data } = await axios.post(`${adminBase(tenantId)}/${documentType}/default`);
    return data;
  } catch (err) {
    return catchErr(err);
  }
};

export const updatePdfTemplateAdminApi = async (_token, tenantId, id, template) => {
  try {
    const { data } = await axios.put(`${adminBase(tenantId)}/${id}`, template);
    return data;
  } catch (err) {
    return catchErr(err);
  }
};

export const deletePdfTemplateAdminApi = async (_token, tenantId, id) => {
  try {
    const { data } = await axios.delete(`${adminBase(tenantId)}/${id}`);
    return data;
  } catch (err) {
    return catchErr(err);
  }
};
